import React from 'react';
import { Icon } from './Icon.jsx';

/**
 * CategoryPill — BRAND.md §8.3. Active = pistachio bg / ink text with deep
 * pistachio border; inactive = white / ink with line border. Optional leading
 * Lucide icon (category glyph):
 * pass `icon` (a registry name) for the common case, or `iconElement` (a
 * pre-rendered node) when the icon comes from a dynamic per-category lookup
 * (e.g. a DB-driven category taxonomy) rather than a fixed name.
 * Compose a horizontally-scrollable row of these for the category nav.
 */
export function CategoryPill({ label, icon, iconElement, active = false, onClick, style }) {
  const [hover, setHover] = React.useState(false);
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={active}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 8,
        padding: '9px 16px', minHeight: 40, whiteSpace: 'nowrap',
        borderRadius: 'var(--radius-pill)', cursor: 'pointer',
        fontFamily: 'var(--font-body)', fontSize: 14, fontWeight: 600,
        border: active ? '1px solid var(--sedra-pistachio-deep)' : '1px solid var(--sedra-line)',
        background: active ? 'var(--sedra-pistachio)' : (hover ? 'var(--sedra-sage-wash)' : 'var(--sedra-card)'),
        color: 'var(--sedra-ink)',
        transition: 'background var(--motion-micro)', ...style,
      }}
    >
      {iconElement || (icon && <Icon name={icon} size={16} color={active ? 'var(--sedra-forest)' : 'var(--sedra-sage-ink)'} />)}
      {label}
    </button>
  );
}
